import React from "react";

interface ResourceSelectionTabProps {
  state: {
    description: string;
    modification_instructions: string;
    provider: string;
    modification_type: string;
  };
  policyMode: "existing" | "new" | undefined;
  showRegenerate: boolean;
  showProgress: boolean;
  onDescriptionChange: (value: string) => void;
  onModificationInstructionsChange: (value: string) => void;
  onProviderChange: (value: string) => void;
  onModificationTypeChange: (value: string) => void;
  onGenerate: () => void;
  onModify: () => void;
}

const ResourceSelectionTab: React.FC<ResourceSelectionTabProps> = ({
  state,
  policyMode,
  showRegenerate,
  showProgress,
  onDescriptionChange,
  onModificationInstructionsChange,
  onProviderChange,
  onModificationTypeChange,
  onGenerate,
  onModify
}) => {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-4">Define Policy Requirement</h2>

      <div className="space-y-6">
       
          <div>
            <label className="font-medium text-sm">
              Policy Description <span className="text-red-500">*</span>
            </label>
            <textarea
              className="mt-1 border p-3 rounded w-full h-32 font-mono text-sm"
              placeholder="E.g., Deny creation of S3 buckets without server-side encryption"
              value={state.description}
              onChange={(e) => onDescriptionChange(e.target.value)}
            />
          </div>
        
        {(policyMode === "existing" || showRegenerate) && (
          <div>
            <label className="font-medium text-sm">
              Additional Instructions
              <span className="text-red-500">*</span>
            </label>
            <textarea
              className="mt-1 border p-3 rounded w-full h-32 font-mono text-sm"
              placeholder="E.g., Add encryption requirement, Update policy scope, etc."
              value={state.modification_instructions}
              onChange={(e) => onModificationInstructionsChange(e.target.value)}
            />
          </div>
        )}

        <div>
          <label className="font-medium text-sm">
            Cloud Platform <span className="text-red-500">*</span>
          </label>
          <select
            className="mt-1 border p-3 rounded w-full"
            value={state.provider || ""}
            onChange={(e) => onProviderChange(e.target.value)}
          >
            <option value="" hidden>
              select
            </option>
            <option>AWS</option>
            <option>Azure</option>
            <option>GCP</option>
          </select>
        </div>

        {(policyMode === "existing" || showRegenerate) && (
          <div>
            <label className="font-medium text-sm">
              Modification Type<span className="text-red-500">*</span>
            </label>
            <select
              className="mt-1 border p-3 rounded w-full"
              value={state.modification_type || "modify"}
              onChange={(e) => onModificationTypeChange(e.target.value)}
            >
              <option value="modify">modify</option>
              <option value="fix">fix</option>
              <option value="enhance">enhance</option>
            </select>
          </div>
        )}
      </div>

      <div className="flex gap-4 mt-4">
        {policyMode === "existing" || showRegenerate ? (
          <button
            className="px-4 py-2 text-white rounded bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onModify}
            disabled={
              showProgress ||
              state.modification_instructions === "" ||
              !state.provider
            }
          >
            Modify Policy
          </button>
        ) : (
          <button
            className="px-4 py-2 text-white rounded bg-primary disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={onGenerate}
            disabled={
              showProgress ||
              state.description === "" ||
              !state.provider
            }
          >
            Generate Policy
          </button>
        )}
      </div>
    </div>
  );
};

export default ResourceSelectionTab;
